import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authHeader, handleResponse } from "../Services/fack.backend";

const PrivateRoute = () => {
  const location = useLocation();
  const login = JSON.parse(localStorage.getItem("login"))
  const jwt_token = localStorage.getItem("token");
  const [authenticated, setAuthenticated] = useState(login);

  useEffect(() => {
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    localStorage.setItem("authenticated", authenticated);
    localStorage.setItem("login", login);
  }, []);

  // ✅ Bypass authentication for any route that includes "/maps"
  if (location.pathname.includes("/maps")) {
    return <Outlet />;
  }

  return login || authenticated || jwt_token ? (
    <Outlet />
  ) : (
    <Navigate to={`${process.env.PUBLIC_URL}/login`} />
  );
};

export default PrivateRoute;